import {Checkbox, IconButton, TableCell} from '@mui/material';
import {CloseOutlined, Done} from '@mui/icons-material';
import styles from './NewTable.module.scss';
import {Row, TableEditRowProps} from 'components/NewTable/types';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import {useTranslation} from 'react-i18next';

type TableEditRowActionsProps<T extends Row> = Pick<
    TableEditRowProps<T>,
    'tableConfig' | 'isItemSelected' | 'onClose' | 'draggableProvided'
> & {
    onSubmit: () => void;
    isValid: boolean;
    styleProps?: Record<string, any>;
};

export const TableEditRowActions = <T extends Row>({
    tableConfig,
    isItemSelected,
    onSubmit,
    isValid,
    onClose,
    draggableProvided,
    styleProps,
}: TableEditRowActionsProps<T>) => {
    const {canDelete, withOrders} = tableConfig;

    const {t} = useTranslation('common');

    return (
        <>
            <TableCell
                padding='none'
                className={styles.sticky}
                style={styleProps}
            >
                <span
                    {...draggableProvided?.dragHandleProps}
                    style={{
                        display: withOrders ? 'initial' : 'none',
                        verticalAlign: 'middle',
                    }}
                >
                    <DragIndicatorIcon color='disabled' />
                </span>

                {canDelete && (
                    <span>
                        <Checkbox
                            disabled
                            color='primary'
                            checked={isItemSelected}
                        />
                    </span>
                )}
                <span>
                    <IconButton
                        disabled={!isValid}
                        onClick={onSubmit}
                        title={t('save')}
                    >
                        <Done />
                    </IconButton>
                </span>
                <span>
                    <IconButton
                        onClick={onClose}
                        title={t('cancel2')}
                    >
                        <CloseOutlined color='error' />
                    </IconButton>
                </span>
            </TableCell>
        </>
    );
};
